export default __webpack_public_path__ + "static/media/icon-1.19a0bb98.png";